var map = {
	"./logo-alphabet.svg": 532,
	"./logo-amazon-2.svg": 533,
	"./logo-amazon.svg": 569,
	"./logo-azercell.svg": 570,
	"./logo-bank-of-america.svg": 571,
	"./logo-barclays.svg": 572,
	"./logo-bbc.svg": 573,
	"./logo-bloomberg.svg": 534,
	"./logo-bnp-paribas.svg": 574,
	"./logo-booking.svg": 575,
	"./logo-citibank.svg": 576,
	"./logo-cnbc.svg": 535,
	"./logo-cnbc2.svg": 577,
	"./logo-coca-cola-auto.svg": 536,
	"./logo-coca-cola-white.svg": 1472,
	"./logo-coca-cola.svg": 578,
	"./logo-deloitte.svg": 579,
	"./logo-experian.svg": 580,
	"./logo-facebook.svg": 581,
	"./logo-forbes.svg": 537,
	"./logo-g.svg": 1473,
	"./logo-goldman-sachs-new.svg": 582,
	"./logo-goldman-sachs.svg": 1419,
	"./logo-google-new.svg": 583,
	"./logo-google.svg": 584,
	"./logo-h.svg": 585,
	"./logo-henkel.svg": 586,
	"./logo-hsbc-new.svg": 587,
	"./logo-hsbc.svg": 1420,
	"./logo-ikea-new.svg": 588,
	"./logo-ikea.svg": 1474,
	"./logo-infineon.svg": 589,
	"./logo-instagram-icon.svg": 538,
	"./logo-instagram.svg": 590,
	"./logo-jp-morgan.svg": 591,
	"./logo-jti.svg": 592,
	"./logo-linkedin.svg": 593,
	"./logo-meta-new.svg": 539,
	"./logo-meta.svg": 1421,
	"./logo-morgan-stanley-new.svg": 594,
	"./logo-morgan-stanley.svg": 1422,
	"./logo-netflix.svg": 1423,
	"./logo-oracle.svg": 540,
	"./logo-paypal.svg": 595,
	"./logo-pwc-new.svg": 541,
	"./logo-pwc.svg": 1475,
	"./logo-spotify.svg": 1424,
	"./logo-tesla.svg": 596,
	"./logo-usa-today.svg": 542,
	"./logo-visa.svg": 597,
	"./logo-walmart.svg": 543,
	"./logo-wsj.svg": 544,
	"./logo-youtube.svg": 598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 615;